document.addEventListener('change', async function (event) {
    const checkbox = event.target.closest('.js-necesita-factura');

    if (!checkbox) return;

    const previousState = !checkbox.checked;

    checkbox.disabled = true;

    try {
        const response = await fetch(routes.cart_update_url, {
            ...fetchConfig(),
            body: JSON.stringify({
                attributes: {
                    'Necesitas factura': checkbox.checked ? 'Sí' : ''
                }
            })
        });

        if (!response.ok) {
            throw new Error('No se pudo actualizar el carrito');
        }

        await response.json();
    } catch (error) {
        console.error('Error al guardar Necesitas factura:', error);

        checkbox.checked = previousState;
    } finally {
        checkbox.disabled = false;
    }
});